import React from 'react';
import ReactDOM from 'react-dom';

import Voucher from './voucher';

import './style.less';

const { Order } = Mobi2Go;
const element = document.querySelector('[data-view="order-voucher"]');

Order.onReady(() => ReactDOM.render(<Voucher />, element));

// Add support host page element hooks
Mobi2Go.UI.views.order_voucher = {
    $el: element,
};
